import Skeleton from "@mui/material/Skeleton";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useUserById } from "@/hooks/users/useUserById";
import { DeviceStatusOverviewData } from "@/models/DeviceStatusOverviewData";
import { getUserDisplayName } from "@/utilities/user/getUserDisplayName";

export function DriverCell({ row }: GridRenderCellParams<DeviceStatusOverviewData>) {
  const { data: driver, isLoading } = useUserById(row.driverId);

  if (!row.driverId) return <></>;
  if (isLoading) return <Skeleton width="100%" variant="text" />;
  if (!driver) return <></>;

  return <>{getUserDisplayName(driver)}</>;
}
